<div class="input-group app-search-group">
  <ng-content select="[search-prefix]"></ng-content>

  <input
    type="text"
    class="form-control app-search-control border-0 bg-transparent shadow-none min-w-0"
    [placeholder]="placeholder"
    [attr.aria-label]="placeholder || buttonText"
    [ngModel]="searchText"
    (ngModelChange)="searchTextChange.emit($event)"
    (keyup.enter)="search.emit()">

  @if (searchText) {
    <button class="btn app-search-clear-button me-1" type="button" (click)="clearSearch()" aria-label="Исчисти пребарување">
      <fa-icon [fixedWidth]="true" [icon]="faXmark"></fa-icon>
    </button>
  }

  <button
    class="btn app-search-button primary-btn app-btn-square"
    type="button"
    [attr.aria-label]="buttonText"
    (click)="search.emit()">
    <span class="d-none fw-bold d-sm-inline me-1">{{ buttonText }}</span>
    <fa-icon [fixedWidth]="true" [icon]="faSearch"></fa-icon>
  </button>
</div>
